export const DEFAULT_PORT = 4000;

export const SERVER_APP_ID = 'serverApp';
